export const getFieldErrorKeys = (
  errors: Record<string, string> | undefined,
  ...paths: string[]
): string[] => {
  const normalize = (path: string) => path.replace(/\[(\d+)\]/g, ".$1");
  const expected = paths.map(normalize);
  return Object.keys(errors ?? {}).filter(
    (key) => Boolean(errors?.[key]) && expected.includes(normalize(key)),
  );
};
